export function formatPhoneNumber(str?: string) {
	if (!str) {
		return '';
	}

	// Filter only numbers
	const cleaned = str.replace(/\D/g, '').replace(/^(7|8)/g, '');

	// Check if the length is correct
	const match = cleaned.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);

	if (match) {
		return `+7 ${match[1]} ${match[2]}-${match[3]}-${match[4]}`;
	}

	return str;
}
